export interface ITabSubjectAction {
    id?: number | null;
    action: Action;
}

export enum Action {
    Add = "add",
    Delete = "delete",
    Update = "update",
}
